import { render } from "./MD.vue?vue&type=template&id=06bd9893"
import script from "./MD.vue?vue&type=script&lang=js"
export * from "./MD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__